// Remembers the viewer's last History Grid/Tree choice across reloads and sessions.
// Best-effort; storage may be unavailable (private mode, quota).

import { HISTORY_VIEW } from 'Pods/ThreeDStudio/Store/constants'

export const HISTORY_VIEW_KEY = 'ai_studio_history_view'

const VALID_VIEWS = new Set(Object.values(HISTORY_VIEW))

export const saveHistoryView = (view) => {
  if (!VALID_VIEWS.has(view)) return

  try {
    window.localStorage.setItem(HISTORY_VIEW_KEY, view)
  } catch (_) {
    // No-op.
  }
}

export const readStoredHistoryView = () => {
  try {
    const stored = window.localStorage.getItem(HISTORY_VIEW_KEY)
    return VALID_VIEWS.has(stored) ? stored : undefined
  } catch (_) {
    return undefined
  }
}
